import React from 'react';
import Reflux from 'reflux';
import DurationPicker from 'main/components/show/cuesheet/presetDurationPicker.jsx';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import classNames from 'classnames';
import TimeUtil from 'time';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import RoleHelper from 'shared/lib/role';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import OverrideIcon from './overrideIcon.jsx';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import PopoverActions from 'flux/actions/PopoverActions';
import PopoverStore from 'flux/stores/PopoverStore';
import UIRegions from 'shared/constants/UIRegions';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

/**
 * Item Preset Duration component
 *
 */
export default React.createClass({
  mixins: [
    PureRenderMixin,
    Reflux.connectFilter(PopoverStore, 'showArrowIcons', (popovers) =>
      popovers.get(UIRegions.CuesheetPresetDurationArrows),
    ),
  ],

  propTypes: {
    user: React.PropTypes.object,
    item: React.PropTypes.any.isRequired,
    rowIndex: React.PropTypes.number.isRequired,
    displayPresetDuration: React.PropTypes.bool,
  },

  displayName: 'ItemPresetTime',

  render() {
    const {
      displayPresetDuration,
      presetDurationDisplayType,
      item,
      rowIndex,
      simple,
      user,
      isSelected,
      value,
    } = this.props;

    if (!displayPresetDuration) return null;

    let presetDurationText = TimeUtil.getShorthandFormattedPresetDuration(
      value,
    );

    if (presetDurationDisplayType === TimeDisplayTypes.sixDigitTime) {
      presetDurationText = TimeUtil.getFormattedDuration(value);
    }
    if (presetDurationDisplayType === TimeDisplayTypes.presetTime) {
      presetDurationText = TimeUtil.getFormattedPresetDuration(value);
    }

    const displayPresetClock = item.get('displayPresetClock');

    const wrapperClasses = classNames('cs-wrapper-preset-time', {
      'show-on-hover': !displayPresetClock,
    });

    if (!this._hasAdmin()) {
      return (
        <span className={wrapperClasses}>
          {this._getDirectionalIconNode()}
          {this._getDisplayNode(presetDurationText)}
        </span>
      );
    }

    let isManualTime = true;

    const placement = simple ? 'top' : 'left';

    if (
      !item.get('presetDurationInSeconds') &&
      !item.get('presetDurationInReverse')
    )
      isManualTime = false;

    return (
      <span className={wrapperClasses} onClick={() => this._handleClick()}>
        {this._getDirectionalIconNode()}
        <DurationPicker
          {...{ item, rowIndex, simple, user, isSelected }}
          displayType={presetDurationDisplayType}
          durationText={presetDurationText}
          displayPresetClock={item.get('displayPresetClock')}
          presetDurationInReverse={item.get('presetDurationInReverse')}
          placement={placement}
          value={value}
          onChange={this._handleChange}
          onTab={this._handleTab}
          displayNode={this._getDisplayNode(presetDurationText)}
          showResetButton={isManualTime}
        />
        {this._getTogglePresetNode()}
      </span>
    );
  },

  _handleClick() {
    const { isSelected, rowIndex } = this.props;

    if (readOnlyHelper.alertPastEventNotEditable()) {
      return;
    }

    if (isSelected) {
      const popoverId = EditableCellTypes.ItemPresetDuration + rowIndex;
      PopoverActions.show(popoverId);
    } else {
      this._select();
    }
  },

  _getDisplayNode(presetDurationText) {
    const { item, value } = this.props;

    const field = 'presetDurationInSeconds';

    const overrideFlag = item.get(field);

    const classes = classNames(
      'cs-preset-time-cell read-only',
      { 'cs-preset-time-cell-over': value < 0 },
      { 'time-override-flag': overrideFlag },
      { 'input-duration-wrapper': !this._hasAdmin() },
    );

    const presetDurationCell = (
      <div className={classes}>{presetDurationText}</div>
    );

    return presetDurationCell;
  },

  _getDirectionalIconNode() {
    const { rowIndex, item } = this.props;
    const { showArrowIcons } = this.state;

    const field = 'presetDurationInSeconds';

    const hasOverride = item.get(field) ? true : false;
    /**
     * Show the directional icon only for items that don't have a preset
     */
    let showDirectionalIcon = showArrowIcons && !hasOverride;
    if (item.get('presetDurationInReverse')) showDirectionalIcon = false;

    const directionalIconWidth = 15;
    const directionIconStyles = {
      position: 'relative',
      display: 'inline-block',
      width: directionalIconWidth,
    };

    let directionalIconNode = showDirectionalIcon ? (
      <span style={directionIconStyles}>
        <Icon
          className="cs-timers-flag"
          name={
            item.get('presetDurationBackwardAdjusted')
              ? 'arrow-up'
              : 'arrow-down'
          }
          ours
        />
      </span>
    ) : null;

    //Add a "spacer" if the hover icon isn't present
    if (!hasOverride && !showArrowIcons) {
      directionalIconNode = <span style={directionIconStyles}></span>;
    }

    return (
      <span>
        {directionalIconNode}
        <OverrideIcon
          onClick={this._handleOverride}
          onMouseEnter={() =>
            PopoverActions.show(UIRegions.CuesheetPresetDurationArrows)
          }
          onMouseLeave={() =>
            PopoverActions.hide(UIRegions.CuesheetPresetDurationArrows, true)
          }
          {...{ rowIndex, item, field }}
          reverseField={'presetDurationInReverse'}
        />
      </span>
    );
  },

  _hasAdmin() {
    const { teamId, eventId, user } = this.props;
    return RoleHelper.hasEventAdminRole(user, teamId, eventId);
  },

  _getTogglePresetNode() {
    const displayPresetClock = this.props.item.get('displayPresetClock');

    let iconName = displayPresetClock ? 'eye' : 'eye-slash';

    return (
      <Icon name={iconName} onClick={() => this._togglePresetDuration()} />
    );
  },

  _togglePresetDuration() {
    const { item, rowIndex } = this.props;

    const displayPresetClock = item.get('displayPresetClock');

    CuesheetCellActions.saveItemTimeField(
      rowIndex,
      'displayPresetClock',
      !displayPresetClock,
    );
  },

  _select() {
    CuesheetCellActions.selectTimeCell(
      this.props.rowIndex,
      EditableCellTypes.ItemPresetDuration,
    );
  },

  _handleChange(durationInSeconds) {
    const { value } = this.props;

    if (value === durationInSeconds) return;

    CuesheetCellActions.saveItemTimeField(
      this.props.rowIndex,
      'presetDurationInSeconds',
      durationInSeconds,
    );
  },

  _handleTab() {
    CuesheetCursorActions.moveCursorRight();
  },

  _handleOverride() {
    const { rowIndex } = this.props;

    CuesheetCellActions.saveItemTimeFields(rowIndex, {
      presetDurationInSeconds: 0,
      presetDurationInReverse: false,
    });

    PopoverActions.hide(UIRegions.CuesheetPresetDurationArrows, true);
  },
});
